import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var MultiIcon = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M7,7H17V8.79a.49.49,0,0,0,.85.35l2.79-2.79a.5.5,0,0,0,0-.71L17.85,2.85a.5.5,0,0,0-.85.36V5H6A1,1,0,0,0,5,6v4a1,1,0,0,0,2,0ZM17,17H7V15.21a.49.49,0,0,0-.85-.35L3.36,17.65a.5.5,0,0,0,0,.71l2.79,2.79A.5.5,0,0,0,7,20.79V19H18a1,1,0,0,0,1-1V14a1,1,0,0,0-2,0Z"
}), 'MultiIcon');